<template>
	<section class="gaokao-content centerWidth">
		<div class="tb_padding">
			<article>
				<ul class="gkTest-step">
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_aa.png" />
								<span>基本信息</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
					</li>
					<li>
						<div class="step-con step-on flex zhong center">
							<div>
								<img src="../../../image/zn_bb.png" />
								<span>意向选择</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
					</li>
					<li>
						<div class="step-con flex zhong center">
							<div>
								<img src="../../../image/zn_c.png" />
								<span>精确选择</span>
							</div>
						</div>
					</li>
					<li>
						<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
					</li>
					<li>
						<div class="step-con flex zhong center">
							<div>
								<img src="../../../image/zn_d.png" />
								<span>生成志愿表</span>
							</div>
						</div>
					</li>
				</ul>
			</article>
			<article class="tbb_div">
				<!--特殊意向 -->
				<div class="tb_ts">
					<h6 class="line_h1">特殊意向</h6>
					<div class="tbb_radio">
						<ul class="flex">
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(1)" :checked="MilitaryAcademy == '是'" />
								<label>军校</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(2)" :checked="PoliceAcademy == '是'" />
								<label>公安院校</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(3)" :checked="NormalSchool == '是'" />
								<label>公费师范</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(4)" :checked="FreeMedicalOrientation == '是'" />
								<label>免费医学定向</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(5)" :checked="UniversityCampus == '是'" />
								<label>院校分校区</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(6)" :checked="SpecialPlan == '是'" />
								<label>专项计划</label>
							</li>
						</ul>
						<ul class="flex tbb_radio_ul">
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(7)" :checked="PreparatoryEthnic == '是'" />
								<label>预科班/民族班</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(8)" :checked="ForeignCooperation == '是'" />
								<label>中外合作</label>
							</li>
							<li class="flex zhong">
								<input type="checkbox" name="oneBox" @click="setCheckBox(9)" :checked="HighFeeMajor == '是'" />
								<label>高收费专业</label>
							</li>
							<li class="flex zhong tbb_radio_li">
								<label>考研/出国/就业</label>
								<div class="tba_input"><el-input placeholder="请输入" v-model="PostgraduateAbroad"></el-input></div>
							</li>
							<li class="flex zhong tbb_radio_li" style="margin-left: 2em;">
								<label>特殊需求</label>
								<div class="tba_input"><el-input placeholder="请输入" v-model="SpecialNeeds"></el-input></div>
							</li>
						</ul>
					</div>
				</div>
				<!-- 意向专业 -->
				<div class="tb_zy">
					<h6 class="line_h1">意向专业</h6>
					<article class="tb_zye flex zhong wrap">
						<div class="tba_dl flex zhong">
							<label>学科门类</label>
							<div class="tba_input">
								<el-select
									@change="selectChanged"
									@remove-tag="selectChanged"
									v-model="xueTxt"
									multiple
									collapse-tags
									style="margin-left: 20px;"
									placeholder="请选择学科门类"
								>
									<el-option v-for="item in SubjectCategories" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</div>
						</div>
						<div class="tba_dl flex zhong">
							<label>专业类</label>
							<div class="tba_input">
								<el-select v-model="zhunTxt" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择专业类">
									<el-option v-for="item in Professional" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</div>
							<div class="tba_input"><el-input v-model="zyKeyName" placeholder="请输入学科门类/专业类/专业名称"></el-input></div>
						</div>
						<!-- 22-02-14 -->
						<div style="margin-top: 20px;" class="flex zhong">
							<div class="tba_dl flex zhong">
								<label>推荐专业</label>
								<div class="tba_input">
									<!-- <el-select v-model="RecommendProfessionIndex" multiple collapse-tags
										style="margin-left: 20px;" placeholder="请选择推荐专业">
										<el-option v-for="(item,index) in RecommendProfessionList" :key="index"
											:label="item.name" :value="item.id">
										</el-option>
									</el-select> -->
									<el-select v-model="RecommendProfessionIndex" placeholder="请选择推荐专业" style="width: 200px;" :clearable="true">
										<el-option v-for="(item, index) in RecommendProfessionList" :key="index" :label="item.name" :value="item.id"></el-option>
									</el-select>
									<!-- <el-select v-model="RecommendProfessionIndex" multiple collapse-tags
										style="margin-left: 20px;" placeholder="请选择推荐专业">
										<el-option v-for="item in RecommendProfessionList" :key="item.id"
											:label="item.name" :value="item.id">
										</el-option>
									</el-select> -->
								</div>
							</div>
							<div class="flex zhong">
								<button class="gaokao-btn" style="width: 120px;margin: 0 0 0 30px;" @click="getIntendedProfessionalPage(1)">搜索</button>
								<button class="gaokao-btn" style="width: 160px;margin: 0 0 0 30px;background-color: #0079fe;" v-on:click="setAddZYAll">全部加入意向专业</button>
								<button
									class="gaokao-btn"
									v-on:click="clearAddZYAll"
									style="width: 160px;margin: 0 0 0 30px;box-sizing: border-box;border: solid 1px #cccccc;color: #666666;background-color: transparent;"
								>
									清空已选择意向专业
								</button>
							</div>
						</div>
					</article>

					<!-- 02 -->
					<div class="tbb_box flex float">
						<article class="tb_zy_left">
							<article class="table">
								<hgroup class="flex">
									<p>学科门类</p>
									<p>专业类</p>
									<p>专业代码</p>
									<p style="width: 250px;">专业名称</p>
									<p>学位授予门类</p>
									<p>修业年限</p>
									<p>增设年限</p>
									<p style="width: 170px;">操作</p>
								</hgroup>
								<ul v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
									<li class="flex zhong" v-for="(item, index) in listDl" :key="index">
										<p>{{ item.SubjectCategories }}</p>
										<p class="shl">{{ item.Professional }}</p>
										<p>{{ item.ProfessionalCode }}</p>
										<p class="shl" style="color: #0079fe;cursor: pointer;width: 250px;" @click="zhuanYeTo(item.MajorIntroductionId)">
											{{ item.ProfessionalName }}
										</p>
										<p>{{ item.AcademicAwardCategory }}</p>
										<p>{{ item.StudyYears }}</p>
										<p>{{ item.AddYears }}</p>
										<p class="flex zhong center" style="width: 170px;">
											<span v-if="!item.IsCollection" @click="setAddZY(item)">加入意向专业</span>
											<span style="color: #999;border-bottom: none;white-space: nowrap;" v-else>已加入意向专业</span>
										</p>
									</li>
								</ul>
							</article>
							<div v-loading="busy" class="loading " />
							<div v-if="listDl.length === 0" style="text-align: center" class="shuJu">暂无数据</div>
							<div v-if="Nobusy" style="text-align: center" class="shuJu">已加载完了</div>
						</article>

						<article class="tb_zy_you">
							<article class="table">
								<hgroup class="flex">
									<p>
										已选意向专业
										<span v-if="zyList && zyList.length > 0">
											(共
											<span style="color: blue">{{ zyList.length }}</span>
											个)
										</span>
									</p>
								</hgroup>
								<ul>
									<li class="flex" v-for="(item, index) in zyList" :key="index">
										<p class="flex float zhong">
											<strong style="cursor: pointer;" @click="zhuanYeTo(item.MajorIntroductionId)">{{ item.ProfessionalName }}</strong>
											<i class="el-icon-error" @click="delctZYItem(index)"></i>
										</p>
									</li>
								</ul>
							</article>
						</article>
					</div>
				</div>
				<!-- 意向院校 -->
				<div class="tb_yx">
					<h6 class="line_h1">意向院校</h6>
					<article class="tb_zye ">
						<!-- 22-02-14 -->
						<div class="yi_xiang">
							<ul>
								<li class="flex float">
									<div class="pyx_h6">院校属地</div>
									<div class="pyx_you flex wrap">
										<p :class="isYuanShua == index ? 'on' : ''" @click="onYuanShua(index)" v-for="(item, index) in yuanShuList" :key="index">{{ item.name }}</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校类型</div>
									<div class="pyx_you flex wrap">
										<p :class="isYuanShub == index ? 'on' : ''" @click="onYuanShub(index)" v-for="(item, index) in yuanShubList" :key="index">
											{{ item.name }}
										</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校特色</div>
									<div class="pyx_you flex wrap">
										<p :class="isYuanShuc == index ? 'on' : ''" @click="onYuanShuc(index)" v-for="(item, index) in yuanShucList" :key="index">
											{{ item.name }}
										</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校类别</div>
									<div class="pyx_you flex wrap">
										<p :class="isYuanShud == index ? 'on' : ''" @click="onYuanShud(index)" v-for="(item, index) in yuanShudList" :key="index">
											{{ item.name }}
										</p>
									</div>
								</li>
								<li class="flex float">
									<div class="pyx_h6">院校搜索</div>
									<div class="pyx_you flex ">
										<div class="tba_dl flex zhong">
											<!-- <div class="pyx_h6">推荐院校:</div>
											<el-select v-model="RecommendCollegeIndex" :clearable="true" placeholder="请选择院校"
												style="width: 200px;">
												<el-option v-for="(item, index) in RecommendCollegeList" :key="index"
													:label="item.name" :value="item.id"></el-option>
											</el-select> -->
											<div class="tba_input" style="width: 200px;"><el-input placeholder="请输入院校名称" v-model="yxKeyName"></el-input></div>
										</div>
										<div class="flex zhong">
											<button class="gaokao-btn" style="width: 120px;margin: 0 0 0 20px;" @click="getIntendedCollegesByPage(1)">搜索</button>
											<button class="gaokao-btn" style="width: 160px;margin: 0 0 0 20px;background-color: #0079fe;" v-on:click="setAddYXAll">
												全部加入意向院校
											</button>
											<button
												class="gaokao-btn"
												v-on:click="clearAddYXAll"
												style="width: 160px;margin: 0 0 0 20px;box-sizing: border-box;border: solid 1px #cccccc;color: #666666;background-color: transparent;"
											>
												清空已选择意向院校
											</button>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</article>

					<!-- 02 -->
					<div class="tbb_box flex float">
						<article class="tb_zy_left">
							<article class="table">
								<hgroup class="flex">
									<p>学校名称</p>
									<p>院校属地</p>
									<p>院校类型</p>
									<p>院校类别</p>
									<p>院校特色</p>
									<p>主管部门</p>
									<p>操作</p>
								</hgroup>
								<ul v-infinite-scroll="loadMore2" infinite-scroll-disabled="busy2" infinite-scroll-distance="10">
									<li class="flex zhong" v-for="(item, index) in listName" :key="index">
										<p style="color: #0079fe;cursor: pointer;" @click="xueXiaoTo(item.SchoolName)">{{ item.SchoolName }}</p>
										<p>{{ item.Location }}</p>
										<p>{{ item.Type1 }}</p>
										<p>{{ item.Type2 }}</p>
										<p>{{ item.Feature }}</p>
										<p>{{ item.Director }}</p>
										<p class="flex zhong center">
											<span v-if="!item.IsCollection" @click="setAddYX(item)">加入意向院校</span>
											<span style="color: #999;border-bottom: none;" v-else>已加入意向院校</span>
										</p>
									</li>
								</ul>
							</article>
							<div v-loading="busy2" class="loading " />
							<div v-if="listName.length === 0" style="text-align: center" class="shuJu">暂无数据</div>
							<div v-if="Nobusy2" style="text-align: center" class="shuJu">已加载完了</div>
						</article>
						<article class="tb_zy_you">
							<article class="table">
								<hgroup class="flex">
									<p>
										已选意向院校
										<span v-if="yxList && yxList.length > 0">
											(共
											<span style="color: blue">{{ yxList.length }}</span>
											个)
										</span>
									</p>
								</hgroup>
								<ul>
									<li class="flex" v-for="(item, index) in yxList" :key="index">
										<p class="flex float zhong">
											<strong style="cursor: pointer;" @click="xueXiaoTo(item.SchoolName)">{{ item.SchoolName }}</strong>
											<i class="el-icon-error" @click="delctYXItem(index)"></i>
										</p>
									</li>
								</ul>
							</article>
						</article>
					</div>
				</div>
				<!-- 意向省份 -->
				<div class="tb_sf">
					<h6 class="line_h1" style="margin-bottom: 20px;">意向省份</h6>
					<div class="yi_head flex zhong">
						<div class="yi_all flex zhong" @click="SelectAllCity()">
							<img :src="isSelectAllCity ? require('../../../image/aa.png') : require('../../../image/a.png')" />
							<span>全选</span>
						</div>
						<button type="button" @click="ClearAllCity()">清空</button>
						<p>
							已选
							<span>{{ selectCityNum }}</span>
							个城市
						</p>
					</div>
					<!-- <div class="yi_hot flex float">
						<p>热门城市:</p>
						<div class="yi_hot_div flex wrap">
							<p :class="isHot == index ? 'on' : ''" @click="onHotTab(index)"
								v-for="(item, index) in hotList" :key="index">北京市</p>
						</div>
					</div> -->
					<div class="tb_city">
						<p>选择省份:</p>
						<ul class="flex wrap">
							<!--  :class="item.isClass ? '' : 'on'" -->
							<li :class="item.selectNum > 0 ? 'zhan on' : 'zhan'" v-for="(item, index) in cityList" :key="index" @click="selectChildCity(index)">
								<span>{{ item.Name }}</span>
								<p v-if="item.selectNum > 0">{{ item.selectNum == item.Children.length ? 'all' : item.selectNum > 0 ? item.selectNum : '' }}</p>
							</li>
						</ul>
					</div>
				</div>
			</article>
			<div class=" flex zhongc center">
				<button class="gaokao-btn" style="margin: 50px 20px;" @click="goNext(0)">上一步</button>
				<button class="gaokao-btn" @click="goNext(2)" style="margin: 50px 20px;">下一步</button>
			</div>
		</div>

		<!-- 选择专业 22.2.14-->
		<aside class="popup flexCenter" v-if="isZhuan">
			<div class="zhuan_bai">
				<img src="../../../image/vol-del-t.png" @click="isZhuan = false" />
				<div class="zhuan_h6">选择专业</div>
				<div style="height: 400px;overflow: auto;">
					<div class="zhuan_list flex wrap"><p v-for="(item, index) in zhuanList" :key="index">计算机1</p></div>
				</div>
			</div>
		</aside>

		<!-- 城市选择 -->
		<aside class="popup flexCenter" v-if="isCityPopup">
			<div class="zhuan_bai">
				<img src="../../../image/vol-del-t.png" @click="isCityPopup = false" />
				<div class="yi_all flex zhong" @click="SelectCityAll">
					<img :src="currCity.selectNum == currCity.Children.length ? require('../../../image/aa.png') : require('../../../image/a.png')" />
					<span>全选</span>
				</div>
				<div class="city_gao">
					<ul class="flex wrap">
						<li class="flex zhong" v-for="(item, index) in currCity.Children" :key="index" @click="chooseChildCity(index)">
							<div class="yi_all flex zhong">
								<img :src="!item.isSelect ? require('../../../image/a.png') : require('../../../image/aa.png')" />
								<span>{{ item.Name }}</span>
							</div>
						</li>
					</ul>
				</div>
				<div style="padding: 20px 0 0 0;"><button type="button" @click="ConfirmCity">确认选择</button></div>
			</div>
		</aside>
	</section>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
export default {
	directives: {
		infiniteScroll
	},
	data() {
		return {
			Id: 0,
			loading: false,
			finished: false,
			show: false,
			isCheng: false,
			isZy: false,
			isYiPop: false,
			isZyPop: false,
			isOneDiv: false,
			zyKeyName: '',
			listDl: [],
			isYuan: false,
			yxpage: 0,
			yxKeyName: '',
			yxfinished: false,
			yxloading: false,
			listName: [],
			cityList: [],
			isXue: false,
			isXzColor: false,
			xueTxt: [],
			columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
			iszyColor: false,
			zhunTxt: [],
			xueColumns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
			isZhun: false,
			MilitaryAcademy: '',
			PoliceAcademy: '',
			NormalSchool: '',
			FreeMedicalOrientation: '',
			UniversityCampus: '',
			SpecialPlan: '',
			PreparatoryEthnic: '',
			ForeignCooperation: '',
			HighFeeMajor: '',
			PostgraduateAbroad: '',
			SpecialNeeds: '',
			IntendedMajor: '',
			InterestedColleges: '',
			IntendedProvince: '',
			Professional: [], // 专业类
			SubjectCategories: [], // 科学门类
			page: 0,
			yxList: [],
			zyList: [],
			IntendedProvinceList: [], // 默认赋值
			busy: true,
			Nobusy: false,
			busy2: true,
			Nobusy2: false,
			listData: [],
			// 22-2-14
			isYuanShua: 0,
			yuanShuList: [
				{
					name: '不限'
				},
				{
					name: '北京市'
				},
				{
					name: '河北省'
				},
				{
					name: '山西省'
				},
				{
					name: '辽宁省'
				},
				{
					name: '吉林省'
				},
				{
					name: '黑龙江省'
				},
				{
					name: '江苏省'
				},
				{
					name: '浙江省'
				},
				{
					name: '安徽省'
				},
				{
					name: '福建省'
				},
				{
					name: '江西省'
				},
				{
					name: '山东省'
				},
				{
					name: '河南省'
				},
				{
					name: '湖北省'
				},
				{
					name: '湖南省'
				},
				{
					name: '广东省'
				},
				{
					name: '海南省'
				},
				{
					name: '四川省'
				},
				{
					name: '贵州省'
				},
				{
					name: '云南省'
				},
				{
					name: '陕西省'
				},
				{
					name: '甘肃省'
				},
				{
					name: '青海省'
				},
				{
					name: '台湾省'
				},
				{
					name: '内蒙古'
				},
				{
					name: '广西壮族'
				},
				{
					name: '西藏'
				},
				{
					name: '宁夏回族'
				},
				{
					name: '新疆维吾尔'
				},
				{
					name: '天津市'
				},
				{
					name: '上海市'
				},
				{
					name: '重庆市'
				},
				{
					name: '香港'
				},
				{
					name: '澳门'
				}
			],
			isYuanShub: 0,
			yuanShubList: [
				{
					name: '不限'
				}
			],
			isYuanShuc: 0,
			yuanShucList: [
				{
					name: '不限'
				},
				{
					name: '985'
				},
				{
					name: '211'
				},
				{
					name: '双一流'
				},
				{
					name: '国家重点'
				},
				{
					name: '省重点'
				}
			],
			isYuanShud: 0,
			yuanShudList: [
				{
					name: '不限'
				},
				{
					name: '公办'
				},
				{
					name: '民办'
				},
				{
					name: '中外/港澳'
				}
			],
			hotList: [{}, {}, {}, {}, {}],
			isHot: 0,
			isAllBox: true,
			// 专业
			isZhuan: false,
			zhuanList: [{}, {}, {}, {}, {}, {}, {}, {}],
			// 全选
			isAllxuan: true,
			cityListPop: [
				{
					isAllBox: true,
					text: '城市名称'
				},
				{
					isAllBox: true,
					text: '城市名称'
				},
				{
					isAllBox: true,
					text: '城市名称'
				},
				{
					isAllBox: true,
					text: '城市名称'
				},
				{
					isAllBox: true,
					text: '城市名称'
				}
			],
			isCityPopup: false,
			RecommendProfessionList: [
				{
					id: 0,
					name: '全部'
				}
			],
			RecommendProfessionIndex: 0,
			RecommendCollegeList: [
				{
					id: 0,
					name: '全部'
				}
			],
			RecommendCollegeIndex: 0,
			currCity: null,
			selectCityNum: 0, // 已选择的城市数量
			isSelectAllCity: false // 城市全选
		};
	},
	// 加载
	created() {
		var that = this;
		that.getCollegesMold();
		console.log('firstId:' + that.$parent.firstId);
		if (that.$parent.firstId > 0) {
			that.$api.HtppRequest(
				'SystemData/GetIntentionalChoiceByVid?vid=' + that.$parent.firstId,
				'GET',
				{},
				function(res) {
					console.log('获取信息', res);
					if (res.query) {
						var obj = res.query;
						that.Id = obj.Id;
						that.MilitaryAcademy = obj.MilitaryAcademy;
						that.PoliceAcademy = obj.PoliceAcademy;
						that.NormalSchool = obj.NormalSchool;
						that.FreeMedicalOrientation = obj.FreeMedicalOrientation;
						that.UniversityCampus = obj.UniversityCampus;
						that.SpecialPlan = obj.SpecialPlan;
						that.PreparatoryEthnic = obj.PreparatoryEthnic;
						that.ForeignCooperation = obj.ForeignCooperation;
						that.HighFeeMajor = obj.HighFeeMajor;
						that.PostgraduateAbroad = obj.PostgraduateAbroad;
						that.SpecialNeeds = obj.SpecialNeeds;
						that.zyList = obj.IntendedMajor === '' ? [] : JSON.parse(obj.IntendedMajor);
						that.yxList = obj.InterestedColleges === '' ? [] : JSON.parse(obj.InterestedColleges);
						that.IntendedProvinceList = obj.IntendedProvince === '' ? [] : JSON.parse(obj.IntendedProvince);
						that.getIntendedProfessionalByType();
						that.getIntendedCollegesByPage(1);
						that.getRegionByPid(0);
						that.GetRecommendProfession();
						that.GetRecommendCollege();
					} else {
						that.getIntendedProfessionalByType();
						that.getIntendedCollegesByPage(1);
						that.getRegionByPid(0);
						that.GetRecommendProfession();
						that.GetRecommendCollege();
					}
				},
				function(err) {
					console.log(err);
					that.getIntendedProfessionalByType();
					that.getIntendedCollegesByPage(1);
					that.getRegionByPid(0);
				}
			);
		} else {
			that.getIntendedProfessionalByType();
			that.getIntendedCollegesByPage(1);
			that.getRegionByPid(0);
			that.GetRecommendProfession();
			that.GetRecommendCollege();
		}
	},
	methods: {
		getCollegesMold() {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/CollegesMold',
				'GET',
				{},
				function(res) {
					console.log('院校类型', res);
					if (res.code==0) {
						var newList = res.data;
						that.yuanShubList= [
							{
								name: '不限'
							}
						]
						if(newList.length>0){
							newList.map(a=>{
								that.yuanShubList.push({
									name: a
								})
							});
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 获取推荐专业
		GetRecommendProfession: function() {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/IntendedProfessionalData?primarily=' + that.$parent.selectType,
				'GET',
				that.info,
				function(res) {
					console.log('获取推荐专业', res);
					if (res.code === 0) {
						var list = res.data.recommendType;
						var newList = [
							{
								id: 0,
								name: '全部'
							}
						];
						var index = 0;
						list.map(a => {
							index++;
							newList.push({
								id: index,
								name: a
							});
						});
						that.RecommendProfessionList = newList;
					}
				},
				function(res) {}
			);
		},
		// 选择推荐专业
		SelectRecommendProfession: function(id) {
			this.RecommendProfessionIndex = id;
		},
		// 获取推荐院校
		GetRecommendCollege: function() {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/IntendedCollegesData?primarily=' + that.$parent.selectType,
				'GET',
				that.info,
				function(res) {
					console.log('获取推荐院校', res);
					if (res.code === 0) {
						var list = res.data.recommendType;
						var newList = [
							{
								id: 0,
								name: '全部'
							}
						];
						var index = 0;
						list.map(a => {
							index++;
							newList.push({
								id: index,
								name: a
							});
						});
						that.RecommendCollegeList = newList;
					}
				},
				function(res) {}
			);
		},
		// 选择推荐院校
		SelectRecommendCollege: function(id) {
			this.RecommendCollegeIndex = id;
		},
		zhuanYeTo(id) {
			var routeUrl = this.$router.resolve({
				path: '/majorInfo',
				query: {
					Id: id
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		xueXiaoTo(id) {
			var routeUrl = this.$router.resolve({
				path: '/schoolinfo',
				query: {
					schoolname: id
				}
			});
			// this.$router.push('/schoolinfo');
			window.open(routeUrl.href, '_blank');
		},
		allView(item) {
			item.isAllBox = !item.isAllBox;
		},
		onYuanShua(index) {
			this.isYuanShua = index;
		},
		onYuanShub(index) {
			this.isYuanShub = index;
		},
		onYuanShuc(index) {
			this.isYuanShuc = index;
		},
		onYuanShud(index) {
			this.isYuanShud = index;
		},
		onHotTab(index) {
			this.isHot = index;
		},
		// 22-2-14
		selectChanged() {
			this.getProfessional();
		},
		delctZYItem(ixd) {
			this.zyList.splice(ixd, 1);
			this.setListZY();
		},
		delctZy() {
			this.zyList = [];
			this.setListZY();
			this.isZyPop = false;
		},
		delctYXItem(ixd) {
			this.yxList.splice(ixd, 1);
			this.setListYX();
		},
		delctYx() {
			this.yxList = [];
			this.setListYX();
			this.isYiPop = false;
		},
		setListZY() {
			this.listDl.map(a => {
				a.IsCollection = false;
				this.zyList.map(b => {
					if (a.Id === b.Id) {
						a.IsCollection = true;
					}
				});
			});
		},
		setListYX() {
			this.listName.map(a => {
				a.IsCollection = false;
				this.yxList.map(b => {
					if (a.Id === b.Id) {
						a.IsCollection = true;
					}
				});
			});
		},
		setAddZY(obj) {
			obj.IsCollection = true;
			this.zyList.push(obj);
			console.log(this.zyList);
		},
		setAddZYAll() {
			var list = this.listDl;
			var newList = this.zyList && this.zyList.length > 0 ? this.zyList : [];
			list.map(a => {
				var isJoin = false;
				a.IsCollection = true;
				newList.map(b => {
					if (a.Id === b.Id) {
						isJoin = true;
					}
				});
				if (!isJoin) {
					newList.push(a);
				}
			});
			this.zyList = newList;
			console.log(this.zyList);
		},
		clearAddZYAll: function() {
			this.listDl.map(a => {
				a.IsCollection = false;
			});
			this.zyList = [];
		},
		setAddYX(obj) {
			obj.IsCollection = true;
			this.yxList.push(obj);
		},
		setAddYXAll() {
			// obj.IsCollection = true;
			var list = this.listName;
			var newList = this.yxList && this.yxList.length > 0 ? this.yxList : [];
			list.map(a => {
				var isJoin = false;
				a.IsCollection = true;
				newList.map(b => {
					if (a.Id === b.Id) {
						isJoin = true;
					}
				});
				if (!isJoin) {
					newList.push(a);
				}
			});
			this.yxList = newList;
			// this.yxList.push(obj);
		},
		clearAddYXAll: function() {
			this.listName.map(a => {
				a.IsCollection = false;
			});
			this.yxList = [];
		},
		getIntendedProfessionalByType() {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetIntendedProfessionalByType?Primarily=' + that.$parent.selectType,
				'GET',
				{},
				function(res) {
					if (res.flag) {
						console.log(res);
						// that.Professional = res.data.Professional;
						that.SubjectCategories = res.data;
						that.getIntendedProfessionalPage(1);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		getProfessional() {
			var that = this;
			that.zhunTxt = [];
			if (that.xueTxt.length === 0) {
				that.Professional = [];
			} else {
				console.log(that.xueTxt);
				var subjectCategories = '';
				that.xueTxt.map(a => {
					if (subjectCategories === '') {
						subjectCategories += a;
					} else {
						subjectCategories += ',' + a;
					}
				});
				console.log(subjectCategories);
				that.$api.HtppRequest(
					'SystemData/GetProfessional?subjectCategories=' + subjectCategories,
					'GET',
					{},
					function(res) {
						if (res.flag) {
							that.Professional = res.data;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			}
		},
		getRegionByPid(pid) {
			var that = this;
			that.$api.HtppRequest(
				'SystemData/GetRegionByPid?pid=' + pid,
				'GET',
				{},
				function(res) {
					console.log('省份', res);
					if (res.flag) {
						var clist = res.list;
						clist.map(a => {
							a.isClass = false;
							a.selectNum = 0;
							a.Children.map(c => {
								c.isSelect = false;
							});
						});
						that.cityList = clist;
						if (that.IntendedProvinceList.length > 0) {
							that.IntendedProvinceList.map(a => {
								if (a.ParentId === a.Id) {
									that.cityList.map(b => {
										if (a.Id === b.Id) {
											b.isClass = true;
											b.Children.map(v => {
												b.selectNum += 1;
												v.isSelect = true;
											});
										}
									});
								}else{
									that.cityList.map(b => {
										if (a.ParentId === b.Id) {
											b.isClass = true;
											b.Children.map(v => {
												if (a.Id === v.Id) {
													b.selectNum += 1;
													v.isSelect = true;
												}
											});
										}
									});
								}
							});
							that.GetAllCityNum();
						}
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		// 显示市
		selectChildCity: function(index) {
			this.currCity = this.cityList[index];
			this.isCityPopup = true;
		},
		// 选择市
		chooseChildCity: function(index) {
			this.currCity.Children[index].isSelect = !this.currCity.Children[index].isSelect;
			this.GetCityNum();
		},
		// 市全选
		SelectCityAll: function() {
			if (this.currCity.selectNum === this.currCity.Children.length) {
				this.currCity.Children.map(a => {
					a.isSelect = false;
				});
				this.currCity.selectNum = 0;
			} else {
				this.currCity.Children.map(a => {
					a.isSelect = true;
				});
				this.currCity.selectNum = this.currCity.Children.length;
			}
			this.GetAllCityNum();
		},
		// 确认选择的城市
		ConfirmCity: function() {
			var that = this;
			this.cityList.map(a => {
				if (a.Id === that.currCity.Id) {
					a = that.currCity;
				}
			});
			this.GetAllCityNum();
			this.isCityPopup = false;
		},
		// 获取选择的城市数量
		GetCityNum: function() {
			var selectNum = 0;
			this.currCity.Children.map(a => {
				if (a.isSelect) {
					selectNum++;
				}
			});
			this.currCity.selectNum = selectNum;
		},
		// 获取所有选择的城市数量
		GetAllCityNum: function() {
			var num = 0;
			var isSelectAll = true;
			this.cityList.map(a => {
				num += a.selectNum;
				if (!a.isSelect) {
					isSelectAll = false;
				}
			});
			this.selectCityNum = num;
			this.isSelectAllCity = isSelectAll;
		},
		// 所有城市全选
		SelectAllCity: function() {
			var isSelectAll = !this.isSelectAllCity;
			var num = 0;
			this.cityList.map(a => {
				a.Children.map(b => {
					b.isSelect = isSelectAll;
				});
				num += isSelectAll ? a.Children.length : 0;
				a.selectNum = isSelectAll ? a.Children.length : 0;
			});
			this.isSelectAllCity = isSelectAll;
			this.selectCityNum = num;
		},
		// 清空所有城市
		ClearAllCity: function() {
			var isSelectAll = false;
			var num = 0;
			this.cityList.map(a => {
				a.Children.map(b => {
					b.isSelect = isSelectAll;
				});
				num += isSelectAll ? a.Children.length : 0;
				a.selectNum = isSelectAll ? a.Children.length : 0;
			});
			this.isSelectAllCity = isSelectAll;
			this.selectCityNum = num;
		},
		getIntendedProfessionalPage(pg) {
			var that = this;
			console.log({
				page: pg,
				size: 10,
				subjectCategories: that.xueTxt,
				professional: that.zhunTxt,
				keyName: that.zyKeyName
			});
			if (pg === 1) {
				that.Nobusy = false;
			}
			// console.log('1111111111111', that.RecommendProfessionIndex);
			that.$api.HtppRequest(
				'SystemData/GetIntendedProfessionalPage',
				'POST',
				{
					page: pg,
					size: 10,
					subjectCategories: that.xueTxt.length === 0 ? '' : JSON.stringify(that.xueTxt),
					professional: that.zhunTxt.length === 0 ? '' : JSON.stringify(that.zhunTxt),
					keyName: that.zyKeyName,
					Primarily: that.$parent.selectType, // 1.本科 2.专科
					RecommendType: that.RecommendProfessionIndex > 0 ? that.RecommendProfessionList[that.RecommendProfessionIndex].name : '' // 推荐类型/推荐专业
				},
				function(res) {
					console.log('获取列表', res);
					that.busy = false;
					if (res.flag) {
						var list = that.listDl;
						if (pg === 1) {
							list = [];
						}
						if (res.list.length > 0) {
							res.list.map(a => {
								list.push(a);
							});
							that.page = pg;

							if (res.list.length < 10) {
								that.Nobusy = true;
							}
						} else {
							if (pg >= 1) {
								that.Nobusy = true;
							}
						}
						that.listDl = list;
						if (that.zyList.length > 0) {
							that.setListZY();
						}
					} else {
						if (pg >= 1) {
							that.Nobusy = true;
						}
					}
					that.busy = false;
					console.log('that.listDl', that.listDl, that.busy);
				},
				function(err) {
					console.log(err);
					that.Nobusy = true;
				}
			);
		},
		// 获取院校
		getIntendedCollegesByPage(pg) {
			var that = this;
			if (pg === 1) {
				that.Nobusy2 = false;
			}
			that.$api.HtppRequest(
				'SystemData/GetIntendedCollegesByPage',
				'POST',
				{
					page: pg,
					size: 10,
					name: that.yxKeyName,
					Primarily: that.$parent.selectType, // 1.本科 2.专科
					Location: that.isYuanShua > 0 ? that.yuanShuList[that.isYuanShua].name : '', // 所在地
					Type1: that.isYuanShub > 0 ? that.yuanShubList[that.isYuanShub].name : '', // 院校类型
					Type2: that.isYuanShud > 0 ? that.yuanShudList[that.isYuanShud].name : '', // 院校类别
					Feature: that.isYuanShuc > 0 ? that.yuanShucList[that.isYuanShuc].name : '', // 特色
					RecommendType: that.RecommendCollegeIndex > 0 ? that.RecommendCollegeList[that.RecommendCollegeIndex].name : '' // 推荐类型/推荐院校
				},
				function(res) {
					console.log('获取列表', res);
					if (res.flag) {
						var list = that.listName;
						if (pg === 1) {
							list = [];
						}
						if (res.list.length > 0) {
							res.list.map(a => {
								list.push(a);
							});
							that.yxpage = pg;

							if (res.list.length < 10) {
								that.Nobusy2 = true;
							}
						} else {
							if (pg >= 1) {
								that.Nobusy2 = true;
							}
						}
						that.listName = list;
						if (that.yxList.length > 0) {
							that.setListYX();
						}
					} else {
						if (pg >= 1) {
							that.Nobusy2 = true;
						}
					}
					that.busy2 = false;
				},
				function(err) {
					console.log(err);
					if (pg > 1) {
						that.Nobusy2 = true;
					}
				}
			);
		},
		goNext(id) {
			var that = this;
			// 保存数据；
			var IntendedMajor = [];
			var InterestedColleges = [];
			var IntendedProvince = [];
			that.zyList.map(a => {
				IntendedMajor.push(a);
			});
			that.yxList.map(b => {
				InterestedColleges.push(b);
			});
			// that.cityList.map(c => {
			// 	if (c.isClass) {
			// 		IntendedProvince.push(c);
			// 	}
			// });
			if(that.cityList.length>0){
				that.cityList.map(c => {
					if (c.selectNum) {
						if(c.Children&&c.Children.length>0){
							var SelectName = '';
							if (c.Name.includes('市')) {
								SelectName = c.Name.replace('市', '');
							} else if (c.Name.includes('省')) {
								SelectName = c.Name.replace('省', '');
							} else if (c.Name.includes('壮族自治区')) {
								SelectName = c.Name.replace('壮族自治区', '');
							} else if (c.Name.includes('维吾尔自治区')) {
								SelectName = c.Name.replace('维吾尔自治区', '');
							} else if (c.Name.includes('回族自治区')) {
								SelectName = c.Name.replace('回族自治区', '');
							} else if (c.Name.includes('自治区')) {
								SelectName = c.Name.replace('自治区', '');
							} else {
								SelectName = c.Name;
							}
							console.log('判断是否全选',c.selectNum==c.Children.length);
							if(c.selectNum==c.Children.length){
								var item = {
									Name: SelectName,
									ParentId: c.Id,
									FullName: c.Name,
									isClss: true,
									Id: c.Id
								};
								IntendedProvince.push(item);
							}else{
								
								c.Children.map(a => {
									if (a.isSelect) {
										var item = {
											Name: SelectName,
											ParentId: c.Id,
											FullName: c.Name,
											isClss: true,
											Id: ''
										};
										var citysName = '';
										if (a.Name.includes('市')) {
											citysName = a.Name.replace('市', '');
										} else if (a.Name.includes('自治区')) {
											citysName = a.Name.replace('自治区', '');
										} else if (a.Name.includes('区')) {
											citysName = a.Name.replace('区', '');
										} else if (a.Name.includes('自治县')) {
											citysName = a.Name.replace('自治县', '');
										} else if (a.Name.includes('自治州')) {
											citysName = a.Name.replace('自治州', '');
										} else {
											citysName = a.Name;
										}
										// citysName = a.Name;
										item.Name = item.Name + '-' + citysName;
										item.Id = a.Id;
										IntendedProvince.push(item);
									}
								});
							}
						}
						
						
					}
				});
			}
			
			console.log('IntendedProvince',IntendedProvince);
			that.$api.HtppRequest(
				'SystemData/SaveIntentionalChoice',
				'POST',
				{
					Id: that.Id,
					VolunteerId: that.$parent.firstId,
					MilitaryAcademy: that.MilitaryAcademy,
					PoliceAcademy: that.PoliceAcademy,
					NormalSchool: that.NormalSchool,
					FreeMedicalOrientation: that.FreeMedicalOrientation,
					UniversityCampus: that.UniversityCampus,
					SpecialPlan: that.SpecialPlan,
					PreparatoryEthnic: that.PreparatoryEthnic,
					ForeignCooperation: that.ForeignCooperation,
					HighFeeMajor: that.HighFeeMajor,
					PostgraduateAbroad: that.PostgraduateAbroad,
					SpecialNeeds: that.SpecialNeeds,
					IntendedMajor: IntendedMajor.length === 0 ? '' : JSON.stringify(IntendedMajor),
					InterestedColleges: InterestedColleges === 0 ? '' : JSON.stringify(InterestedColleges),
					IntendedProvince: IntendedProvince === 0 ? '' : JSON.stringify(IntendedProvince)
				},
				function(res) {
					console.log('保存', res);
					if (res.flag) {
						that.$parent.selectId = res.SId;
						that.$parent.goNext(id);
					} else {
						that.$util.showError(res.msg ? res.msg : '失败');
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		setCheckBox(id) {
			if (id === 1) {
				if (this.MilitaryAcademy === '') {
					this.MilitaryAcademy = '是';
				} else {
					this.MilitaryAcademy = '';
				}
			}
			if (id === 2) {
				if (this.PoliceAcademy === '') {
					this.PoliceAcademy = '是';
				} else {
					this.PoliceAcademy = '';
				}
			}
			if (id === 3) {
				if (this.NormalSchool === '') {
					this.NormalSchool = '是';
				} else {
					this.NormalSchool = '';
				}
			}
			if (id === 4) {
				if (this.FreeMedicalOrientation === '') {
					this.FreeMedicalOrientation = '是';
				} else {
					this.FreeMedicalOrientation = '';
				}
			}
			if (id === 5) {
				if (this.UniversityCampus === '') {
					this.UniversityCampus = '是';
				} else {
					this.UniversityCampus = '';
				}
			}
			if (id === 6) {
				if (this.SpecialPlan === '') {
					this.SpecialPlan = '是';
				} else {
					this.SpecialPlan = '';
				}
			}
			if (id === 7) {
				if (this.PreparatoryEthnic === '') {
					this.PreparatoryEthnic = '是';
				} else {
					this.PreparatoryEthnic = '';
				}
			}
			if (id === 8) {
				if (this.ForeignCooperation === '') {
					this.ForeignCooperation = '是';
				} else {
					this.ForeignCooperation = '';
				}
			}
			if (id === 9) {
				if (this.HighFeeMajor === '') {
					this.HighFeeMajor = '是';
				} else {
					this.HighFeeMajor = '';
				}
			}
		},
		loadMore() {
			console.log('Nobusy:' + this.Nobusy);
			if (!this.Nobusy) {
				this.busy = true;
				setTimeout(() => {
					console.log('翻页');
					var pg = parseInt(this.page) + 1;
					this.getIntendedProfessionalPage(pg);
				}, 1500);
			}
		},
		loadMore2() {
			if (!this.Nobusy2) {
				this.busy2 = true;
				setTimeout(() => {
					console.log('翻页');
					var pg = parseInt(this.yxpage) + 1;
					this.getIntendedCollegesByPage(pg);
				}, 1500);
			}
		}
	}
};
</script>

<style scoped>
.zhuan_bai button {
	width: 200px;
	height: 40px;
	border-radius: 4px;
	background-color: #444444;
	font-size: 14px;
	color: #fff;
	text-align: center;
	line-height: 40px;
	margin: 0 auto;
	display: block;
	cursor: pointer;
}

.city_gao li {
	width: 33.33%;
}

.city_gao {
	height: 300px;
	overflow: auto;
}

.zhuan_bai > img {
	display: block;
	width: 20px;
	height: 20px;
	position: absolute;
	right: 20px;
	top: 20px;
	z-index: 2;
	cursor: pointer;
}

.zhuan_list p {
	width: 130px;
	height: 40px;
	background-color: #e6e6e6;
	text-align: center;
	line-height: 40px;
	text-align: center;
	font-size: 14px;
	border-radius: 4px;
	margin-top: 14px;
	margin-right: 20px;
}

.zhuan_list p:active {
	background-color: #00527020;
}

.zhuan_list p:nth-child(3n + 3) {
	margin-right: 0;
}

.zhuan_h6 {
	text-align: center;
	font-size: 18px;
	color: #333333;
	font-weight: normal;
}

.zhuan_bai {
	border-radius: 10px;
	width: 510px;
	overflow: hidden;
	padding: 20px 40px;
	background-color: #fff;
	position: relative;
}

/* zhuan_bai */

.tb_city li p {
	width: 24px;
	height: 24px;
	border-radius: 50px;
	background-color: #005270;
	color: #fff;
	text-align: center;
	line-height: 24px;
	font-size: 12px;
	text-align: center;
	line-height: 24px;
	position: absolute;
	right: -9px;
	top: -9px;
	margin: 0;
	z-index: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.yi_hot_div p.on {
	color: #fff;
	background-color: #005371;
	border: solid 1px #005371;
}

.yi_hot_div p {
	width: 90px;
	height: 36px;
	box-sizing: border-box;
	padding: 0 10px;
	font-size: 14px;
	color: #666666;
	text-align: center;
	line-height: 36px;
	border: solid 1px #444444;
	cursor: pointer;
	margin-right: 10px;
	margin-top: 10px;
}

.yi_hot_div {
	width: calc(100% - 92px);
}

.yi_hot > p {
	font-size: 14px;
	color: #333333;
	line-height: 36px;
	margin-top: 10px;
}

.yi_hot {
	padding: 14px 0;
}

.yi_head p span {
	color: #0079fe;
}

.yi_head p {
	font-size: 14px;
	color: #333333;
}

.yi_head button {
	width: 70px;
	height: 30px;
	background-color: #fff;
	border-radius: 4px;
	border: solid 1px #dedede;
	text-align: center;
	line-height: 30px;
	display: block;
	margin: 0 23px;
	cursor: pointer;
}

.yi_all span {
	font-size: 14px;
	color: #333333;
}

.yi_all img {
	display: block;
	width: 40px;
	height: 40px;
	cursor: pointer;
}

.pyx_you p {
	margin-top: 0px;
	min-width: 66px;
	height: 30px;
	font-size: 14px;
	color: #666666;
	text-align: center;
	line-height: 30px;
	cursor: pointer;
	border-radius: 4px;
	margin-right: 30px;
}

.pyx_you p.hover {
	opacity: 0.7;
}

.pyx_you p.on:hover {
	opacity: 1;
}

.pyx_you p.on {
	color: #fff;
	background-color: #005371;
}

.pyx_you {
	width: calc(100% - 80px);
}

.pyx_h6 {
	font-size: 14px;
	color: #333333;
	width: 80px;
	line-height: 30px;
	margin-top: 10px;
}

.yi_xiang li {
	margin-top: 10px;
}

/* 2.14 */

.tb_city li:nth-child(11n + 11) {
	margin-right: 0;
}

.tb_city li.on {
	background-color: #333;
	color: #fff;
}

.tb_city li {
	width: 96px;
	height: 36px;
	padding: 0 10px;
	background-color: #eeeeee;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	position: relative;
	border: solid 1px #dddddd;
	margin: 10px 10px 0 0;
}

.tb_city li span {
	line-height: 36px;
	display: block;
	text-align: center;
	width: 100%;
	height: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.tb_city > p {
	font-size: 14px;
	color: #333333;
}

.tb_zy_you p i {
	cursor: pointer;
	color: #fc8982;
}

.tb_zy_you .table li p strong {
	width: calc(100% - 20px) !important;
	font-size: 14px;
	color: #666;
	font-weight: normal;
}

.tb_zy_you .table li p {
	text-align: left;
	padding: 0 1em;
}

.tb_zy_you .table hgroup p,
.tb_zy_you .table li p {
	width: 100% !important;
}

.tb_zy_you::before {
	content: '';
	width: 25px;
	height: 2px;
	background-color: #f5f5f5;
	position: absolute;
	z-index: 0;
	left: -24px;
	top: 32px;
	margin: 0;
}

/* 01 */
.table p span {
	font-size: 14px;
	color: #333;
	padding-bottom: 8px;
	border-bottom: solid 1px #333;
	line-height: initial;
	margin: 0 10px;
	cursor: pointer;
}

.table li p {
	font-size: 14px;
	width: calc(100% / 6);
	text-align: center;
	color: #666666;
	height: fit-content;
}

.table li:last-child {
	border-bottom: none;
}

.table li p:last-child {
	border-right: none;
}

.table li {
	padding: 20px 0;
	border-bottom: solid 1px #e6e6e6;
}

.table ul {
	overflow: auto;
	height: calc(100% - 60px);
}

.table hgroup p {
	font-size: 14px;
	background-color: #eaeaea;
	width: calc(100% / 6);
	line-height: 60px;
	text-align: center;
}

.table {
	height: 100%;
	overflow: hidden;
	border: solid 1px #e6e6e6;
	box-sizing: border-box;
}

/* 01 */

.tb_zy_you {
	width: 226px;
	position: relative;
	z-index: 2;
}

.tb_zy_left {
	width: 910px;
	position: relative;
	z-index: 2;
	height: 100%;
}

.tbb_box {
	height: 500px;
	margin-top: 20px;
	overflow: hidden;
}

/* tbb_box */
.tba_dl label span {
	color: #ff0000;
}

.tba_dl label {
	font-size: 14px;
	color: #333;
	width: 90px;
	text-align: right;
	margin-right: 10px;
}

.tba_dl {
	min-width: 320px;
}

.tb_zye {
	padding: 20px 30px;
	border: solid 1px #dddddd;
}

/* tb_zy */

.tbb_radio_ul {
	margin-top: 20px;
}

.tbb_radio_li {
	width: 315px !important;
}

.tba_input {
	width: 190px;
	margin-left: 20px;
}

.tbb_radio li label {
	font-size: 14px;
	margin-left: 0.5em;
}

.tbb_radio li {
	width: 160px;
}

.tbb_radio ul {
	padding-left: 10px;
}

/* tbb_radio */

.tbb_div > div:first-child {
	margin-top: 20px;
}

.tbb_div > div {
	margin-top: 40px;
}

.line_h1 {
	font-size: 16px;
	color: #333;
	padding-left: 10px;
	position: relative;
	font-weight: normal;
	margin-bottom: 30px;
}

.line_h1::after {
	content: '';
	width: 4px;
	height: 16px;
	border-radius: 50px;
	background-color: #444444;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -8px;
	z-index: 1;
}

.tb_padding {
	padding: 20px 20px 0 20px;
}

.gkTest-step {
	margin-top: 0;
}

.gaokao-content {
	background-color: #fff;
	margin-bottom: 40px;
}

.shuJu {
	font-size: 14px;
	padding: 15px 0 0 0;
}

.gaokao-btn {
	font-size: 14px !important;
}
</style>
